import { render, staticRenderFns } from "./AdminExcel.vue?vue&type=template&id=3b928345&scoped=true&"
import script from "./AdminExcel.vue?vue&type=script&lang=js&"
export * from "./AdminExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b928345",
  null
  
)

export default component.exports